/*
 * GrowthBook A/B test — shared core.
 *
 * To add a test:
 *   1. Create assets/growthbook-<name>.js exposing window.applyXxx
 *   2. Call it from applyFeatureFlags below
 *   3. Add its <script src> in layout/theme.liquid
 *
 * HOLDOUT_FLAG (5% Holdout / 95% Exposed) sets window.ab_enabled; each test
 * reader checks it before applying its variant. To change the holdout, only
 * touch HOLDOUT_FLAG here — no test file needs to change.
 */

const HOLDOUT_FLAG = 'holdout-q2-ono';

const checkHoldout = _ => {
  const holdoutGroup = window._growthbook?.getFeatureValue(HOLDOUT_FLAG, 'OFF');
  if (holdoutGroup === true) {
    document.documentElement.classList.add('ab-enabled');
    window.ab_enabled = true;
  }
};

(() => {
  window.growthbook_queue = window.growthbook_queue || [];
  window.growthbook_queue.push((gb) => {
    const applyFeatureFlags = () => {
      if (window.applyCartTrustBuilder) window.applyCartTrustBuilder(gb);
      // if (window.applyStickyAtc) window.applyStickyAtc(gb);
      // if (window.applyOtherTest) window.applyOtherTest(gb);
      if (window.applyPdpInfographics) window.applyPdpInfographics(gb);
    };

    checkHoldout();
    applyFeatureFlags();
    document.addEventListener('growthbookdata', _ => {
      checkHoldout();
      applyFeatureFlags();
    });
  });
})();
